// 通过 webpack 来获取平台id，见根目录下的 vue.config.js 文件
export const APPID = window.location.host === 'jf.map.qq.com' ? 'formal_score_mail' : 'pre_score_mail';

export default {
  Theme: {
    primary: '#1890FF',
    navTheme: 'light',
    layout: 'sidemenu',
    contentWidth: 'Fixed',
    fixedHeader: false,
    fixSiderbar: false,
    autoHideHeader: false,
    colorWeak: false,
    multiTab: false,
  },
  Storage: {
    namespace: 'tks__',
    name: 'ls',
    storage: 'local',
  },
  BasicConf: {
    platformId: 'image_annotate',
  },
  System: {
    title: '演示项目',
    defaultAvatar: `${process.env.BASE_URL}avatar.jpg`,
  },
};
